function OverallClinical()
{
    return(

        <>
        {(<iframe title="DIGITAL UM - REVIEW DASHBOARD" width="100%" height="675" src="https://app.powerbi.com/reportEmbed?reportId=55a8d58e-0da9-4654-9380-92e16ba20046&autoAuth=true&ctid=dafe49bc-5ac3-4310-97b4-3e44a28cbf18" frameborder="0" allowFullScreen="true"></iframe>)}
        </>
    )
}

export default OverallClinical;